<template>
  <Container type="card-full" v-loading="loading">
    <div slot="header">
      <el-button @click="lodopPrint" type='primary' :loading="btnLoading">打印</el-button>
    </div>

    <div class="bid-notice-content" id="px" ref="px">
      <div class="head-title">成交通知书</div>
      <!--<div class="line"></div>-->
      <div class="line1"></div>
      <div class="l-title">{{psu.comfullname}}：</div>
      <div class="desc-box">
        <div class="desc">
          <div>
            {{+psu.projecttype===2 ?psu.pcomfullname:psu.acomfullname}}的{{psu.projectname}}（项目编号：{{psu.projectcode}}）采用{{psu.prsflgdesc}}方式进行采购，按规定程序进行了{{prsflgName}}、{{+psu.prsflg===1?'评比':'评标'}}，经评审委员会评审，采购人确认，贵公司为本项目的成交供应商。
          </div>
        </div>
        <div class="desc1">成交内容如下：</div>
        <div class="desc2">成交金额：¥ {{psu.psuamt | qfwVal}}（大写金额：<amount :money="String(psu.psuamt)" v-if="psu.psuamt"/>）。</div>
        <div class="desc2">详细采购内容以采购文件为准。</div>
        <div class="desc3">
          请贵公司接此通知书后在三十日内依照《采购法》、《合同法》的规定并按采购文件确定的事项和{{prsflgName1}}文件的承诺与采购人签订采购书面合同。
        </div>
        <div class="desc2">特此通知。</div>
        <div v-if="+psu.projecttype===1">
          <div class="desc4" >采购项目联系人：{{psu.acomfullname}}  {{psu.ausername}}  {{psu.projectatel}}</div>
          <div class="desc4">采购人联系人：{{psu.pcomfullname}}  {{psu.pusername}}  {{psu.projectptel}}</div>
        </div>
        <div v-else>
          <div class="desc4">采购人联系人：{{psu.pcomfullname}}  {{psu.pusername}}  {{psu.projectptel}}</div>
        </div>
        <div class="desc5">
          <div class="imgurl">
            <div v-for="(i,index) in logoUrl" :key="index" class="urlitem">
              <div class="img-posi"><img :src="uploadAddr + i.appendurl" alt=""></div>
              <div class="img-bot">
                  <div>{{i.cosname?i.cosname:i.comfullname}}</div>
                  <div>{{psu.psuconfirmtime | newDate}}</div>
              </div>
            </div>
          </div>
          <!-- <div class="descname">
            <img :src="$store.getters.uploadAddr+psu.amarkappendurl" alt="">
            <span>{{+psu.projecttype===1?psu.acomfullname:psu.pcomfullname}}</span>
            <div >{{psu.psuconfirmtime | newDate}}</div>
          </div> -->
        </div>
      </div>
    </div>
  </Container>
</template>
<script>
  import {getLodop} from '@/assets/js/LodopFuncs'
  import {mapGetters} from 'vuex'
  import utils from '../../assets/js/utils'
  import amount from '../common/amount'
  import request from '@/utils/request'
  // import config from '../../assets/config'
  let LODOP
  export default {
    name: 'projectBiddingNotice',
    filters: {
      newDate (value) {
        return utils.formatterDate(value, 'yyyy年MM月dd日')
      },
      qfwVal(value) {
        return utils.comdify(value)
      }
    },
    data () {
      return {
        psu: {} ,
        type: this.$route.params.type,
        btnLoading: false,
        logoUrl:[],
        loading:false
      }
    },
    created () {
    },
    activated () {
      this.init()
      this.getPsu()
      this.getComListbypid()
    },
    // deactivated () {
    //   console.log(this.$data)
    //   Object.assign(this.$data, {})
    // },
    components: {amount},
    mounted () {
      this.getPsu()
    },
    methods: {
      init(){
        this.logoUrl = []
      },
      async getPsu () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getpsubyid',
          params: {psuid: this.$route.params.psuid}
        })
        if (res.length) {
          this.psu = res[0]
        }
        this.loading = false
      },
      async getComListbypid(){
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getComListbypid',
          params: {projectid: this.$route.params.projectid, cosid:this.$store.getters.loginUser.cosid}
        })
        this.logoUrl = res
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async lodopPrint () {
        var style = document.createElement('link')
        style.href = 'http://39.108.157.187:9600/upload/20201222/1608631002333.css'
        style.rel = 'stylesheet'
        style.type = 'text/css'
        document.getElementById("px").appendChild(style)
        LODOP = await getLodop()
        if (LODOP) {
          LODOP.SET_PRINT_STYLE("FontSize", 10)
          LODOP.ADD_PRINT_HTM(10, 0, "90%", "80%", document.getElementById("px").innerHTML)
          LODOP.PREVIEW()
        }
      }
    },
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      },
      prsflgName () {
        if (this.psu.prsflg == '1') {
          return '竞价'
        }
        else {
          return '开标'
        }
      },
      prsflgName1 () {
        if (this.psu.prsflg == '1') {
          return '竞价'
        }
        else {
          return '投标'
        }
      }
    }
  }
</script>
<style lang="scss" scoped>

  .bid-notice-content {
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    width: 100%;
    /*height: 100vh;*/
    /*text-align: center;*/
    font-size: 14px;
    overflow: auto;
    line-height: 35px;
    /*margin-left: 20px;*/

    .head-title {
      font-weight: bold;
      font-size: 26px;
      color: #000;
      word-wrap: break-word;
      font-weight: bold;
      text-align: center;
      span {
        font-size: 14px;
      }
    }
    .l-title {
      padding-top: 10px;
      font-size: 16px;
      font-weight: bold;
      color: #303133;
    }
    .desc-box {
      text-indent: 1cm;
      .desc {
        text-align: left;
        /*margin: 10px 0;*/
        word-wrap: break-word;
      }
      .desc1 {
        padding-top: 20px;
        font-weight: bold;
      }
      .desc3 {
        padding-top: 20px;
      }
      .desc4 {
        text-indent: 2cm;
        /*padding-top: 20px;*/
        /*padding-bottom: 50px;*/
      }
      .desc5 {
        position: relative;
        padding-top: 100px;
        padding-bottom: 100px;
      }
    }
    .line, .line1 {
      width: 100%;
      background: #000;
    }
    .line {
      height: 4px;
      margin-bottom: 4px
    }
    .line1 {
      height: 2px;
    }

  }
  .descname{
    position: relative;
    right: 300px;
    top: 50px;
  }
  .imgurl{
    position: absolute;
    right: 200px;
    top: 80px;
  }
  .imgurl .urlitem{
    float:right;
  }
  .img-posi{
    position: absolute;
    top: -30px;
  }
  .img-bot{

  }
</style>
